<template>
  <div class="content">
    <div class="content-header">
      <div class="header__text">Not Found</div>
    </div>
  </div>
</template>